<template>
  <select class="form-control form-control-select" :class="classesList" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)">
    <slot></slot>
  </select>
</template>

<script>
import { defineComponent } from "vue"
export default defineComponent({
  props: {
    size: undefined,
    modelValue: null,
  },
  setup( props ){
    let classesList = []
    if(props.size !== undefined){
      classesList.push(`form-control-${props.size}`)
    }
    return {
      classesList,
    }
  }
})
</script>
